
const getColorContrast = (hex?: string) => {
  if (!hex) return null;

  hex = hex.replace('#', '');
  
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);
  
  const brightness = (r * 0.299 + g * 0.587 + b * 0.114);
  
  return brightness > 127 ? 'black' : 'white';
};

const setDefaultColor = () => {
  document.documentElement.style.setProperty(
    '--color-primary-contarst',
    'white',
  );
  document.documentElement.style.setProperty(
    '--color-primary-color',
    '#2B2B2B',
  );
};

const setNewColor = (hex: string, darkMode?: boolean) => {
  let contrast;

  if (darkMode === true) {
    contrast = 'black'
  } else if (darkMode === false) {
    contrast = 'white'
  } else {
    contrast = getColorContrast(hex);
  }

  document.documentElement.style.setProperty(
    '--color-primary-contarst',
    contrast,
  );

  document.documentElement.style.setProperty(
    '--color-primary-color',
    hex
  );
};

const setNewContrast = (contrast: 'white' | 'black') => {
    document.documentElement.style.setProperty(
    '--color-primary-contarst',
    contrast,
  );
};

export const ColorsHelper = {
    getColorContrast,
    setDefaultColor,
    setNewColor,
    setNewContrast
};